import { Box, Button, Chip, Grid } from '@mui/material';
import Alert from '@mui/material/Alert';
import React, { useState } from 'react';
import { IMaterialImportDialog } from '.';
import Api from '../../Api';
import { IMaterial } from '../../interfaces';



export const ImportFormSection: React.SFC<IMaterialImportDialog> = ({ onImported }) => {

    const [uploading, setUploading] = useState(false);
    const [errors, setErrors] = useState<string[]>();
    const [warnings, setWarnings] = useState<string[]>();



    const onChangeFile = async (e: React.ChangeEvent<HTMLInputElement>) => {

        if (e.target.files) {

            setUploading(true);
            setErrors([]);
            setWarnings([]);

            let formData = new FormData();

            formData.append("File", e.target.files[0]);

            Api.Search.import(formData).then((data: any) => {

                if (data.errors)
                    setErrors(data.errors as string[]);

                if (data.warnings)
                    setWarnings(data.warnings as string[]);

                if (data.materials)
                    onImported(data.materials as IMaterial[], data.warnings as string[] ?? []);
                else { console.log("no materials"); }

                setUploading(false);
                e.target.value = "";

            });

        }
    }



    return (
        <Grid item textAlign="center" >

            <Button
                variant="contained"
                component="label"
                size="large"
                disabled={uploading}
            >
                {uploading ? "Uploading" : "Upload"}
                <input
                    hidden
                    accept=".csv"
                    onChange={onChangeFile}
                    type="file"

                />
            </Button>

            {
                errors &&
                errors.map(err => {
                    return <Box sx={{ my: 1 }}><Chip size="small" color="error" label={err} sx={{ whiteSpace: "no-wrap" }} /></Box>
                })
            }

            {
                warnings && warnings.length > 0 &&
                <Alert severity="warning" sx={{ mt: 2 }}>
                    Quantity was not updated for one or more uploaded rows.
                </Alert>
            }

        </Grid >
    );
}
